export var WaterTowerCategory;
(function (WaterTowerCategory) {
    WaterTowerCategory[WaterTowerCategory["Main"] = 50] = "Main";
    WaterTowerCategory[WaterTowerCategory["Upgrade"] = 51] = "Upgrade";
})(WaterTowerCategory || (WaterTowerCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/WaterTowerCategory.ts
// module id = 947
// module chunks = 3